// extracted by mini-css-extract-plugin
module.exports = {"containerIP":"_2Y5pGy4famgfKuwEFzdp1s","messageInfos":"VYNSmkzls_Wi8DVD8vqF3","infoLabel":"ewBql9Lk2W5ct7t36iHxN"};